var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.427734 0.193007H1.48494L4.14968 3.55289V0.323347L5.51101 0.0771484V5.59489H4.30898L1.78907 2.39431V5.59489H0.427734V0.193007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03711 5.59525H10.0284V4.59266H7.4262V3.27627H9.31277V2.20097L7.4262 2.43822V1.19072H9.9633V0.188123H6.03711V5.59525Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 0.188123L11.8078 5.59525H13.0782L14.1306 2.82855L15.1868 5.59525H16.4496L17.9994 0.188123H16.6065L15.6498 3.77757L14.1995 0.0771484H14.0579L12.6496 3.78522L11.67 0.188123H10.2656Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new.0c4811ae.svg";
export { ForwardRef as ReactComponent };